import { ApiService } from "core/services";

class ApiTokenApi extends ApiService {
    constructor() {
        super("apitoken");
    }

    // テナントAPI-Token一覧取得
    getTenantTokens() {
        return this.get("tenant");
    }

    // テナントAPI-Token生成
    generateTenantToken() {
        return this.post("tenant");
    }

    // テナントAPI-Token生成
    updateTenantToken(payload = null) {
        return this.put(`tenant/${payload.id}`, payload);
    }

    // テナントAPI-Token生成
    deleteTenantToken(id) {
        return this.delete(`tenant/${id}`);
    }

    // チームAPI-Token一覧取得
    getTeamTokens(teamsId) {
        return this.get(`teams/${teamsId}`);
    }

    // チームAPI-Token生成
    generateTeamToken(teamsId) {
        return this.post(`teams/${teamsId}`);
    }

    // チームAPI-Token生成
    updateTeamToken(payload = null) {
        return this.put(`teams/${payload.id}`, payload);
    }

    // チームAPI-Token生成
    deleteTeamToken(id) {
        return this.delete(`teams/${id}`);
    }
}

export default ApiTokenApi;